import { useState, useContext, createContext, useEffect } from 'react';
import de from './locales/de.json';
import fr from './locales/fr.json';

const translations = { de, fr };
const TranslationContext = createContext();

// Language detection function
const detectLanguage = () => {
  // Check if user has previously set a preference
  const savedLanguage = localStorage.getItem('preferredLanguage');
  if (savedLanguage && ['de', 'fr'].includes(savedLanguage)) {
    return savedLanguage;
  }
  
  // Detect from browser languages
  const browserLanguages = navigator.languages || [navigator.language];
  
  for (const browserLang of browserLanguages) {
    const langCode = browserLang.split('-')[0].toLowerCase();
    if (['de', 'fr'].includes(langCode)) {
      return langCode;
    }
  }
  
  // Default fallback
  return 'de';
};

export function TranslationProvider({ children }) {
  const [language, setLanguage] = useState(() => detectLanguage());
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };
  
  const changeLanguage = (newLang) => {
    if (newLang === language) return;
    
    // Save user's language preference to localStorage
    localStorage.setItem('preferredLanguage', newLang);
    
    setIsTransitioning(true);
    
    setTimeout(() => {
      setLanguage(newLang);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 150);
  };
  
  return (
    <TranslationContext.Provider value={{ t, language, setLanguage: changeLanguage, isTransitioning }}>
      {children}
    </TranslationContext.Provider>
  );
}

export const useTranslation = () => useContext(TranslationContext);